import React, { FC, useEffect } from 'react'

import { useRouteMatch } from 'react-router-dom'

import { mambaLayoutContextId } from 'components/layout/MambaLayout/Context'
import { CreateBaseUrl } from 'components/layout/MambaLayout/CreateContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { featuredPhotosPopularityReducer } from 'reducers/featuredPhotos/featuredPhotosPopularityReducer'
import { chatMessengerReducer } from 'reducers/messenger/chatMessengerReducer'
import { photoViewerReducer } from 'reducers/photo/photoViewerReducer'
import { photoRatingReducer } from 'reducers/photoRatingReducer'
import { profileReducer } from 'reducers/profile/profileReducer'
import { matchReducer } from 'reducers/rating/matchReducer'
import { photoRatingNextReducer } from 'reducers/rating/photoRatingNextReducer'
import { photoRatingSettingsReducer } from 'reducers/rating/photoRatingSettingsReducer'

import { useClearRatingStore } from './hooks/useClearRatingStore'
import { RatingNextSettingsLayer } from './RatingNextSettingsLayer'

export const RatingWave: FC = () => {
  const { url, path } = useRouteMatch()
  const { vip } = useShallowEqualSelector(({ userReducer: { vip } }) => ({
    vip,
  }))

  const { clearRatingStore } = useClearRatingStore()

  /**
   * Всегда когда уходим с знакомств сбрасываем кеш, для того чтобы получить свежие данные
   */
  useEffect(() => {
    return () => {
      clearRatingStore(true)
    }
  }, [clearRatingStore, vip])

  /**
   * Всегда когда уходим с знакомств сбрасываем кеш, для того чтобы получить свежие данные
   */
  useEffect(() => {
    return () => {
      clearRatingStore(true)
    }
  }, [clearRatingStore])

  return (
    <CreateBaseUrl
      uid="rating"
      contextId={mambaLayoutContextId}
      baseUrl={url}
      basePath={path}
    >
      <RatingNextSettingsLayer />
    </CreateBaseUrl>
  )
}

export default RatingWave

export const asyncReducers = {
  photoRatingReducer,
  photoRatingNext: photoRatingNextReducer,
  profile: profileReducer,
  match: matchReducer,
  photoRatingSettings: photoRatingSettingsReducer,
  featuredPhotosPopularity: featuredPhotosPopularityReducer,
  chatMessengerReducer,
  photoViewerReducer: photoViewerReducer,
}
